import React from 'react'

function Map() {
  return (
    <div>
    </div>
  )
}
export default Map;